export function sortNestedTree(data: any[] = [], compare?: (a: any, b: any) => number): any[] {
  const root = data.map((item) => {
    if (item?.viagsDepartmentChild && item?.viagsDepartmentChild?.length > 0) {
      return { ...item, viagsDepartmentChild: sortNestedTree(item.viagsDepartmentChild, compare) };
    }
    return item;
  });
  return root.sort(compare);
}
